import React from 'react';
import { MapContainer, TileLayer,useMap  } from "react-leaflet";
import './Map.css'
import {showDataOnMap } from './util/helper';

const Map = ({center,zoom,casesType,countries}) => {
   function ChangeView({ center, zoom }) {
    const map = useMap();
    map.setView(center, zoom);
     return null;
   }
  return (
    <div className="map_conatainer">
            <MapContainer center={center} zoom={zoom} casesType={casesType}>
            <ChangeView center={center} zoom={zoom} />
              <TileLayer
               attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
               url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
               {showDataOnMap(countries,casesType)}
            </MapContainer>
        </div>
  )
}
export default Map;
